import MapPhotos from './mapPhotos'
export default MapPhotos
